import { Controller } from '@hotwired/stimulus';
import dobDatepicker from 'date-of-birth-js/dist/js/date-of-birth-js.min.js';
import 'date-of-birth-js/dist/css/date-of-birth-js.min.css';
import moment from 'moment';

export default class extends Controller {
  connect() {
    this.element.form.onsubmit =
      this.disableSubmitIfDobIsBeingSelected.bind(this);
    this.dob = dobDatepicker(this.element, {
      display_mode: 'inline',
      year_range: 100,
      enable_ordinal_number: true,
      show_long_month: false,
      dateFormat: (date) => moment(date).format('DD-MM-YYYY'),
      short_month: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      labels: {
        header_label: 'When is your birthday?',
        select_day_label: 'Select day',
        select_month_label: 'Select month',
        select_year_label: 'Select year',
        reset_button_label: 'Reset and try again',
        date_range_label: 'Year ', //label for year section -> "Year 2000 - 2020"
      },
      alerts: {
        invalid_date_alert: 'Date is invalid',
      },
    });
  }

  disableSubmitIfDobIsBeingSelected(e) {
    ['dob-datepicker__year__button', 'dob-datepicker__day__button'].forEach(
      (className) => {
        if (e.submitter.classList.contains(className)) {
          e.preventDefault();
        }
      }
    );
  }
}
